import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import useBranding from "../core/branding/useBranding";
import { setTheme } from "../core/helpers/helpers";
import { useResponsiveStyle } from "../core/hooks/dimensionProvider";
import useLanguage from "../core/i18n/useLanguage";
import LoadingSpinner from "../ui-lib/components/Loading/LoadingSpinner";

interface Props {
  children: React.ReactNode;
}
const Theme = (props: Props) => {
  const brandingStore = useBranding();
  const languageStore = useLanguage();
  useEffect(() => {
    brandingStore.getBranding().then(() => {
      setTheme(
        brandingStore.currentCss,
        brandingStore.currentFavicon,
        brandingStore.currentTitle,
      );
      languageStore.setCurrentLanguage(
        languageStore.getStoredLanguage() ?? brandingStore.currentLoginLanguage,
      );
    });
  }, []);

  const responsiveClass = useResponsiveStyle<string>({
    mobile: () => "mobile",
    tablet: () => "mobile",
    desktop: () => "desktop",
  });

  if (brandingStore.resolvedBrandKey === undefined) {
    return (
      <div
        className={responsiveClass}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
        }}
      >
        <LoadingSpinner />
      </div>
    );
  }

  return <div className={responsiveClass}>{props.children}</div>;
};
export default observer(Theme);
